
const SpaceSignBoard = ({
    height = 100,
    width = 100,
}: {
    height?: number
    width?: number
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            x={0}
            y={0}
            viewBox="0 0 400 400"
            height={height}
            width={width}
            className="text-primary"
        >
            <path
                d="M293.3 36.7c0-.1-.1-.1 0 0-.1-.1-.1-.1 0 0-.7 2.4-2.2 4.2-4.7 5.2 2.4 1 4 2.8 4.7 5.2v.1-.1c.7-2.4 2.2-4.2 4.7-5.2-2.5-1.1-4.1-2.8-4.7-5.2zM343.5 109.8c0-.1 0 0 0 0s0-.1 0 0c-.7 2.4-2.2 4.2-4.7 5.2 2.4 1 4 2.8 4.7 5.2v.1-.1c.7-2.4 2.2-4.2 4.7-5.2-2.5-1-4.1-2.8-4.7-5.2zM65.2 173c-.7 2.4-2.2 4.2-4.7 5.2 2.4 1 4 2.8 4.7 5.2v.1-.1c.7-2.4 2.2-4.2 4.7-5.2-4.7-2.1-7.8-5.6-9.2-10.5zM87.2 252.4c-.7 2.4-2.2 4.2-4.7 5.2 2.4 1 4 2.8 4.7 5.2v.1-.1c.7-2.4 2.2-4.2 4.7-5.2-2.4-1-4-2.7-4.7-5.2zM43 225.9v-.1.1-.1.1c-1.4 4.9-4.5 8.4-9.4 10.5 4.9 2.1 8 5.6 9.3 10.5v.1-.1.1-.1c1.3-4.9 4.5-8.4 9.3-10.5-4.7-2.1-7.8-5.6-9.2-10.5zM352.8 31.4v-.1.1-.1.1c-1.4 4.9-4.5 8.4-9.4 10.5 4.9 2.1 8 5.6 9.3 10.5v.1-.1.1-.1c1.3-4.9 4.5-8.4 9.3-10.5-4.7-2.1-7.8-5.6-9.2-10.5z"
                fill="#bababa"
            />
            <path
                d="M396.6 385.1c-51.9-46.8-120.6-75.2-196-75.2s-144.1 28.5-196 75.2h392z"
                fill="#fff"
            />
            <path d="M396.6 385.8c-.2 0-.3-.1-.5-.2-13-11.7-27-22.2-41.8-31.4-15-9.3-30.8-17.2-47.2-23.6-33.9-13.3-69.8-20-106.5-20-36.8 0-72.6 6.7-106.5 20-16.3 6.4-32.2 14.3-47.2 23.6-14.8 9.2-28.9 19.7-41.8 31.4-.3.3-.7.2-1-.1-.3-.3-.2-.7.1-1 13-11.7 27.2-22.4 42-31.6 15-9.3 31-17.3 47.4-23.7 34.1-13.4 70.1-20.1 107.1-20.1s73 6.8 107.1 20.1c16.4 6.4 32.4 14.4 47.4 23.7 14.9 9.2 29 19.8 42 31.6.3.3.3.7.1 1-.3.2-.5.3-.7.3z" />
            <path
                d="M33.3 362.3v-11.9s15.9-17.3 35-28c32.7-18.3 49.5-16.1 49.5-16.1l23.3 9.7s-15.4 21.7-46.5 37.4c-22.7 11.5-41.9 15.9-41.9 15.9l-19.4-7z"
                fill="#fff"
            />
            <path d="M52.7 369.9c-.3 0-.6-.2-.7-.6-.1-.4.2-.8.5-.9.2 0 19.4-4.5 41.7-15.8 16-8.1 27.7-17.8 34.7-24.5 6-5.7 9.7-10.3 11-12l-22.3-9.3c-.6-.1-4.8-.4-12.3 1.2-13.6 2.9-27.5 9.7-36.7 14.9-17.6 9.9-32.7 25.7-34.6 27.7v11.7c0 .4-.3.7-.7.7s-.7-.3-.7-.7v-11.9c0-.2.1-.4.2-.5.2-.2 16.2-17.6 35.2-28.2 9.4-5.3 23.4-12.1 37.2-15 8.3-1.7 12.6-1.2 12.7-1.2h.2l23.3 9.7c.2.1.4.3.4.5.1.2 0 .4-.1.6 0 .1-4 5.6-11.7 12.9-7.1 6.8-19 16.6-35.1 24.7-22.5 11.4-41.9 15.9-42.1 15.9 0 .1-.1.1-.1.1z" />
            <path d="M43 351.3c-.3 0-.6-.2-.7-.5-.1-.4 0-.8.4-.9 0 0 5-2 28.7-12.9 23.6-10.9 32.7-20.8 32.7-20.9.3-.3.7-.3 1-.1.3.3.3.7.1 1-.1.1-2.3 2.6-7.6 6.4-4.8 3.5-13.2 9-25.6 14.8-23.8 11-28.6 12.9-28.8 13 0 .1-.1.1-.2.1z" />
            <path
                d="M253.7 314.6s17.5-4.8 19.9-4.8c7.4 0 19 1.3 45.6 13.7s42.5 25.9 42.5 25.9l9.5 15.3s-25.4 3.3-60.3-10.2-52.2-28.2-52.2-28.2l-5-11.7z"
                fill="#fff"
            />
            <path d="M363.8 365.7c-2.6 0-5.8-.1-9.6-.4-9.8-.8-25.3-3.2-43.4-10.2-10-3.9-24.9-10.3-39.3-19.2-8.6-5.3-13.1-9-13.1-9.1-.3-.3-.3-.7-.1-1s.7-.3 1-.1c0 0 4.4 3.7 13 9 7.9 4.9 21.1 12.1 39 19.1 17.9 6.9 33.3 9.4 43 10.1 8 .6 13.5.4 15.8.2l-8.8-14.2c-1.3-1.1-17-14-42.3-25.7-12-5.6-21.8-9.3-29.9-11.4-7.4-1.9-12.1-2.2-15.4-2.2-2 0-14.9 3.5-19.8 4.8-.4.1-.8-.1-.9-.5-.1-.4.1-.8.5-.9 1.8-.5 17.6-4.8 20.1-4.8 8 0 19.8 1.6 45.9 13.8 13.8 6.4 24.7 13.1 31.3 17.6 7.2 4.9 11.3 8.3 11.3 8.4.1 0 .1.1.1.2l9.5 15.3c.1.2.1.5 0 .7-.1.2-.3.4-.6.4.1-.2-2.5.1-7.3.1z" />
            <path d="M351.1 350c-.1 0-.1 0 0 0-.3 0-20.1-2.3-41.9-11.9-6.3-2.8-15.5-7.3-23.5-12.8-4.8-3.3-6.9-5.4-7-5.5-.3-.3-.3-.7 0-1 .3-.3.7-.3 1 0 .1.1 8.5 8.5 30 18 21.6 9.6 41.2 11.8 41.4 11.8.4 0 .7.4.6.8 0 .3-.3.6-.6.6z" />
            <path
                d="M200.8 326c-4.1 2.7-8.4 3.1-13.2.7L173.4 72l13.2-.7L200.8 326z"
                fill="#393f4f"
            />
            <path d="M193.8 329.1c-2.1 0-4.3-.6-6.4-1.7-.2-.1-.4-.3-.4-.6L172.7 72.1c0-.2.1-.4.2-.5.1-.1.3-.2.5-.2l13.2-.7c.4 0 .7.3.8.7L201.5 326c0 .3-.1.5-.3.6-2.4 1.6-4.9 2.5-7.4 2.5zm-5.5-2.8c4.1 2 8 1.8 11.7-.6L185.9 72.1l-11.7.7 14.1 253.5z" />
            <circle
                cx={351.1}
                cy={211.7}
                r={39.5}
                fill="#e2e2e2"
            />
            <path
                d="M358.8 172.9c.2 5.9-.2 12.1-2.1 16.3-5 10.5-12.7 13.8-30.3 22.4-7.2 3.5-10.2 10.2-11.1 16.7 2.8 6 7.1 11.1 12.3 15 1.2-5 3.4-10.5 7.6-15.1 10.5-11.6 26.4-.6 44.9-9.9 4.9-2.5 8.1-6.6 10.2-11.3-2-17-14.8-30.7-31.5-34.1z"
                fill="#bababa"
            />
            <circle
                cx={57.6}
                cy={44.3}
                r={32.7}
                fill="#bababa"
                transform="rotate(-2.144 57.574 44.265)"
            />
            <path
                d="M8 73.3c-2.9 0-4.6-.6-5.2-2-.8-1.9.9-4.5 5.4-8.2 3.9-3.2 9.9-7.2 17.3-11.3.3-.2.8-.1 1 .3.2.3.1.8-.3 1-7.3 4.1-13.2 8-17.1 11.2-5.3 4.4-5.1 6.1-5 6.5.2.5 2.1 2.8 18-1.3 11.1-2.9 25.3-8.1 40-14.6C77 48.4 90.4 41.4 100 35.2c13.8-8.9 13.4-11.9 13.2-12.4-.2-.4-1.3-1.7-8-.8-4.9.7-11.7 2.4-19.6 4.9-.4.1-.8-.1-.9-.5-.1-.4.1-.8.5-.9 8-2.6 14.8-4.3 19.8-5 5.6-.8 8.7-.3 9.5 1.6.7 1.5-.3 3.5-3 6.1-2.4 2.3-6 5-10.7 8.1-9.7 6.2-23.2 13.3-38 19.8C48 62.7 33.7 67.9 22.6 70.8c-5.5 1.4-9.9 2.3-13.2 2.5H8z"
                fill="#8c8c8c"
            />
            <path
                d="m240.7 225.8-131.4-11.5 21.9-25.1-17.3-28.5 131.5 11.4 17.2 28.6z"
                fill="currentColor"
            />
            <path d="M240.7 226.5 109.2 215c-.3 0-.5-.2-.6-.4-.1-.2-.1-.5.1-.7l21.6-24.7-17-28.1c-.1-.2-.1-.5 0-.7.1-.2.4-.4.7-.3l131.5 11.5c.2 0 .4.1.5.3l17.2 28.5c.2.3.1.6-.1.8l-21.9 25.1c-.1.1-.3.2-.5.2zm-130-12.8L240.4 225l21.3-24.5-16.7-27.7-129.7-11.3 16.5 27.3c.2.3.1.6-.1.8l-21 24.1z" />
            <path
                d="M125.6 150.6 257 139.1 235.1 114l17.3-28.5-131.5 11.4-17.2 28.6z"
                fill="currentColor"
            />
            <path d="M125.6 151.3c-.2 0-.4-.1-.5-.2L103.2 126c-.2-.2-.2-.6-.1-.8l17.2-28.5c.1-.2.3-.3.5-.3l131.5-11.5c.3 0 .5.1.7.3.1.2.1.5 0 .7L236 114l21.6 24.7c.2.2.2.5.1.7-.1.2-.3.4-.6.4l-131.5 11.5zm-21-25.9 21.3 24.5 129.7-11.3-21-24.1c-.2-.2-.2-.6-.1-.8L251 86.3 121.3 97.6l-16.7 27.8z" />
        </svg>
    )
}

export default SpaceSignBoard

